import React from 'react';
import { LinkMenu } from './FooterLinkMenu';
import { Banner } from './FooterBanner';
import { Socials } from './FooterSocials';

interface MenusProps {
  banner: FooterBanner;
  socials: FooterSocials;
  firstMenu: FooterSection | undefined;
  secondMenu: FooterSection | undefined;
}

export const Menus = ({
  banner,
  socials,
  firstMenu,
  secondMenu,
}: MenusProps) => {
  return (
    <div className="text-white bg-gray-800">
      <div className="container">
        <div className="grid grid-cols-1 !gap-6 md:grid-cols-2 xl:grid-cols-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 md:col-span-2 xl:col-span-3 !gap-0 md:!gap-6">
            <LinkMenu menu={firstMenu} />
            <div className="grid grid-cols-1 lg:grid-cols-2 lg:col-span-2 md:!gap-x-6 md:!gap-y-6 !gap-y-0">
              <LinkMenu menu={secondMenu} />
              <Socials {...socials} />
            </div>
          </div>
          <div className="xl:col-span-3 md:col-span-2">
            <Banner {...banner} />
          </div>
        </div>
      </div>
    </div>
  );
};
